import createIcon from '../../createIcon';

/**
 * @component @name MedicalServices
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNkgxNlY0QzE2IDIuOSAxNS4xIDIgMTQgMkgxMEM4LjkgMiA4IDIuOSA4IDRWNkg0QzIuOSA2IDIgNi45IDIgOFYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjhDMjIgNi45IDIxLjEgNiAyMCA2Wk0xMCA0SDE0VjZIMTBWNFpNMTYgMTVIMTNWMThIMTFWMTVIOFYxM0gxMVYxMEgxM1YxM0gxNlYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MedicalServices = createIcon('MedicalServices', [
  [
    'path',
    {
      d: 'M20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6ZM10 4H14V6H10V4ZM16 15H13V18H11V15H8V13H11V10H13V13H16V15Z',
      key: '177jt3',
    },
  ],
]);

export default MedicalServices;
